// Member self-service against the QR/digital-pass backend — self-hosted PostgREST
// (Supabase-flavoured) fronting Postgres. Same GoTrue-authenticated pattern as
// vms.js: the member's access token is forwarded as the Bearer token and
// PostgREST/RLS scopes every call to their own passes.
//
// The rpc() helper (with its cold-start retry) was written here and now lives in
// lib/rpc.js so every per-member feature shares one implementation.
import { rpc } from './rpc';

// The signed-in member's claimed passes / e-certificates. [] on any failure.
export async function getMyPasses() {
  try { const d = await rpc('qr_my_passes'); return Array.isArray(d) ? d : []; }
  catch { return []; }
}

// The signed-in member's badge(s): claimed passes plus venue/address/ecert_body
// and the badge_token to encode into a scannable QR (the door scanner reads this
// exact string). [] on any failure.
export async function getMyBadge() {
  try { const d = await rpc('qr_my_badge'); return Array.isArray(d) ? d : []; }
  catch { return []; }
}

// The signed-in member's live profile — display name, email and Ihsan Points
// balance. null on any failure (not signed in, network, cold-start exhausted).
export async function getMyProfile() {
  try {
    const d = await rpc('qr_my_profile');
    return d && typeof d === 'object' ? d : null;
  } catch { return null; }
}

// Email-bound claim: binds every unclaimed pass whose holder-email matches the
// signed-in member. No token in the URL. Returns { ok, claimed }.
export async function claimMine() {
  try {
    const d = await rpc('qr_claim_mine');
    if (d && typeof d.ok === 'boolean') return d;
    return { ok: false, error: (d && (d.error || d.message)) || 'claim_failed' };
  } catch (e) { return { ok: false, error: e.noauth ? 'not_signed_in' : 'network_error' }; }
}

// Claim a pass by its raw QR token. Returns the RPC's own { ok, ... } shape.
export async function claimPass(token) {
  try {
    const d = await rpc('qr_claim', { p_token: token });
    if (d && typeof d.ok === 'boolean') return d;
    return { ok: false, error: (d && (d.error || d.message)) || 'claim_failed' };
  } catch (e) { return { ok: false, error: e.noauth ? 'not_signed_in' : 'network_error' }; }
}
